module.exports = __webpack_public_path__ + "img/logo-title.e2323e60.png";